<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="pt-2 pb-0">REGISTRAR REVERSIÓN DE DETALLE DE SOLICITUD</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pb-0 pt-3">
          <v-form ref="formRef">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  :value="form.clasificador"
                  label="Clasificador"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :value="form.sede_origen"
                  label="Sede Origen"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :value="form.sede_destino"
                  label="Sede Destino"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :value="form.banco_origen"
                  label="Banco Origen"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :value="form.cuenta_origen"
                  label="Cuenta Origen"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <vue-select
                  v-model="cuentaDestinoSeleccionada"
                  class="style-chooser"
                  placeholder="Seleccione Cuenta Destino"
                  label="nro"
                  :options="cuentaDestinoItems"
                  :loading="cargandoCuentas"
                  :disabled="cargandoCuentas"
                  @input="onCuentaDestinoChange">
                  <div slot="no-options">Lo sentimos, no hay opciones de coincidencia.</div>

                  <template #option="{ nro, nombre, descripcion }">
                    <span style="display: block; font-size: 1rem">{{ nro }}</span>
                    {{ descripcion }} - {{ nombre }}
                  </template>
                </vue-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :value="form.banco_destino"
                  label="Banco Destino"
                  outlined
                  dense
                  disabled
                  hide-details></v-text-field>
              </v-col>

              <template v-if="esPagadoParcialmente">
                <v-col cols="12">
                  <div class="text-subtitle-2 mb-1 mt-2">Pagos realizados</div>
                  <v-simple-table dense>
                    <template #default>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fecha</th>
                          <th>N° Comprobante</th>
                          <th class="text-right">Monto (Bs.)</th>
                          <th>Registrado Por</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(pago, i) in pagosDetalle" :key="pago.id">
                          <td>{{ i + 1 }}</td>
                          <td>{{ formatearFecha(pago.fecha) }}</td>
                          <td>{{ pago.numero_comprobante }}</td>
                          <td class="text-right">{{ formatearValorAMoneda(pago.monto) }}</td>
                          <td>{{ pago.registrado_por }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Importe original:</td>
                          <td class="text-right font-weight-bold">{{ formatearValorAMoneda(importeOriginal) }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total pagado:</td>
                          <td class="text-right font-weight-bold">{{ formatearValorAMoneda(totalPagado) }}</td>
                          <td></td>
                        </tr>
                        <tr class="primary--text">
                          <td colspan="3" class="text-right font-weight-bold primary--text">Monto a revertir:</td>
                          <td class="text-right font-weight-bold primary--text">
                            {{ formatearValorAMoneda(montoARevertir) }}
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </template>
                  </v-simple-table>
                </v-col>
              </template>

              <v-col cols="12">
                <v-text-field
                  v-model="form.detalle"
                  label="Detalle"
                  outlined
                  dense
                  clearable
                  :rules="[(v) => !!v || 'El detalle es requerido']"></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field :value="form.importe" label="Importe" outlined dense disabled hide-details></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field :value="form.estado" label="Estado" outlined dense disabled hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mt-3"></v-divider>

        <v-card-actions class="pt-0">
          <v-btn color="blue darken-1" text :disabled="cargando" @click="cerrar">Cerrar</v-btn>
          <v-btn color="blue darken-1" text :disabled="cargando" :loading="cargando" @click="guardar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmacionAccion
      ref="confirmacionGuardar"
      titulo="¿Confirmar registro de reversión?"
      :mensaje="mensajeConfirmacion"
      :realizandoAccion="cargando"
      :maxWidth="700"
      @aceptar="ejecutarGuardado" />
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ConfirmacionAccion from '@/components/ConfirmacionAccion.vue';
import { peticionCuentas2, formatearValorAMoneda, ESTADOS_DETALLE_SOLICITUD } from '../../utils';
import ReversionDetalleSolicitudService from '../../services/reversion-detalle-solicitud';

export default {
  name: 'ModalFormRegistrarReversionDetalleSolicitud',
  components: { ConfirmacionAccion },
  data() {
    return {
      dialog: false,
      cargando: false,
      cargandoCuentas: false,
      cuentaDestinoItems: [],
      cuentaDestinoSeleccionada: null,
      cuentaDestinoDefaultId: null,
      pagosDetalle: [],
      importeOriginal: 0,
      estadoOriginal: null,
      detalleId: null,
      form: {
        solicitud_id: null,
        clasificador_id: null,
        clasificador: null,
        sede_origen_id: null,
        sede_origen: null,
        sede_destino_id: null,
        sede_destino: null,
        banco_origen: null,
        cuenta_origen_id: null,
        cuenta_origen: null,
        banco_destino: null,
        cuenta_destino_id: null,
        cuenta_destino: null,
        detalle: null,
        importe: null,
        estado: 'Reversion',
      },
    };
  },
  computed: {
    mensajeConfirmacion() {
      return `
        <strong>Clasificador:</strong> ${this.form.clasificador || '-'}<br>
        <strong>Sede Origen:</strong> ${this.form.sede_origen || '-'}<br>
        <strong>Banco Origen:</strong> ${this.form.banco_origen || '-'}<br>
        <strong>Cuenta Origen:</strong> ${this.form.cuenta_origen || '-'}<br>
        <strong>Sede Destino:</strong> ${this.form.sede_destino || '-'}<br>
        <strong>Banco Destino:</strong> ${this.form.banco_destino || '-'}<br>
        <strong>Cuenta Destino:</strong> ${this.form.cuenta_destino || '-'} ${this.cuentaDestinoSeleccionada?.id === this.cuentaDestinoDefaultId ? '<em style="color:#4caf50">(por defecto)</em>' : '<em style="color:#ff9800">(modificada)</em>'}<br>
        <strong>Detalle:</strong> ${this.form.detalle || '-'}<br>
        <strong>Importe:</strong> ${this.form.importe || '-'}<br>
        <strong>Estado:</strong> ${this.form.estado || '-'}
      `;
    },
    esPagadoParcialmente() {
      return this.estadoOriginal === ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE;
    },
    totalPagado() {
      return this.pagosDetalle.reduce((sum, p) => sum + parseFloat(p.monto), 0);
    },
    montoARevertir() {
      return this.importeOriginal - this.totalPagado;
    },
  },
  methods: {
    async abrir(detalle, solicitudId) {
      const pagos = detalle.pagos_detalles_solicitudes || [];
      const importeOriginal = parseFloat(detalle.importe);
      const esPagadoParcialmente = detalle.estado === ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE;
      const montoARevertir = esPagadoParcialmente
        ? importeOriginal - pagos.reduce((sum, p) => sum + parseFloat(p.monto), 0)
        : importeOriginal;

      this.pagosDetalle = pagos;
      this.importeOriginal = importeOriginal;
      this.estadoOriginal = detalle.estado;
      this.detalleId = detalle.id;

      this.form = {
        solicitud_id: solicitudId,
        clasificador_id: typeof detalle.clasificador === 'object' ? detalle.clasificador.id : detalle.clasificador_id,
        clasificador:
          typeof detalle.clasificador === 'object'
            ? `${detalle.clasificador.codigo} ${detalle.clasificador.nombre}`
            : detalle.clasificador,
        sede_origen_id: detalle.sede_destino_id,
        sede_origen: detalle.sede_destino,
        sede_destino_id: detalle.sede_origen_id,
        sede_destino: detalle.sede_origen,
        banco_origen: detalle.banco_destino,
        cuenta_origen_id: detalle.cuenta_destino_id,
        cuenta_origen: detalle.cuenta_destino,
        banco_destino: null,
        cuenta_destino_id: null,
        cuenta_destino: null,
        detalle: `Reversión de la solicitud #${detalle.solicitud_id} - Detalle #${detalle.id}`,
        importe: (montoARevertir * -1).toFixed(2),
        estado: 'Reversion',
      };

      this.cuentaDestinoSeleccionada = null;
      this.cuentaDestinoItems = [];
      this.dialog = true;

      await this.obtenerCuentasDestino(detalle.sede_origen_id);

      const cuentaDefault = this.cuentaDestinoItems.find((c) => c.id === detalle.cuenta_origen_id);
      if (cuentaDefault) {
        this.cuentaDestinoDefaultId = cuentaDefault.id;
        this.cuentaDestinoSeleccionada = cuentaDefault;
        this.onCuentaDestinoChange(cuentaDefault);
      }
    },
    async obtenerCuentasDestino(sedeId) {
      this.cargandoCuentas = true;

      try {
        const cuentasDestino = await peticionCuentas2(sedeId, this.$apollo);

        this.cuentaDestinoItems = cuentasDestino?.data?.getSede?.cuentasBancarias ?? [];
      } catch (error) {
        window.console.log(error);
      } finally {
        this.cargandoCuentas = false;
      }
    },
    onCuentaDestinoChange(cuenta) {
      if (!cuenta) {
        this.form.cuenta_destino_id = null;
        this.form.cuenta_destino = null;
        this.form.banco_destino = null;
        return;
      }

      this.form.cuenta_destino_id = cuenta.id;
      this.form.cuenta_destino = cuenta.nro;
      this.form.banco_destino = cuenta.nombre;
    },
    guardar() {
      if (!this.$refs.formRef.validate()) return;

      if (!this.cuentaDestinoSeleccionada) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe seleccionar una cuenta destino',
          type: 'error',
        });
        return;
      }

      this.$refs.confirmacionGuardar.abrir();
    },
    async ejecutarGuardado() {
      this.cargando = true;

      try {
        await ReversionDetalleSolicitudService.revertir(this.detalleId, this.form);

        this.$notify({
          group: 'notifications',
          title: 'Reversión registrada correctamente',
          text: 'Éxito',
          type: 'success',
        });

        this.$refs.confirmacionGuardar.cerrar();
        this.$emit('guardado');
        this.cerrar();
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje;
        const errores = error?.response?.data?.errores;
        const erroresFormateados =
          errores instanceof Object
            ? Object.values(errores)
                .map((e) => e.join(', '))
                .join('<br>')
            : errores;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: erroresFormateados || mensaje || 'Ocurrió un error al registrar la reversión',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    cerrar() {
      this.dialog = false;
      this.cuentaDestinoSeleccionada = null;
      this.cuentaDestinoDefaultId = null;
      this.cuentaDestinoItems = [];
      this.pagosDetalle = [];
      this.importeOriginal = 0;
      this.estadoOriginal = null;
    },
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
    formatearFecha(fecha) {
      if (!fecha) return '-';
      return new Date(fecha).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-data-table td,
::v-deep .v-data-table th {
  padding: 4px 8px;
}

::v-deep tfoot td {
  padding: 4px 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
